import { render, staticRenderFns } from "./DistributionActivityUserRecordListDialog.vue?vue&type=template&id=9c583c40&scoped=true&lang=pug&"
import script from "./DistributionActivityUserRecordListDialog.vue?vue&type=script&lang=ts&"
export * from "./DistributionActivityUserRecordListDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c583c40",
  null
  
)

export default component.exports